import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg, ROLE_HOME } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={ROLE_HOME[user.role]} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      navigate(ROLE_HOME[u.role], { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden bg-[#1C1410] lg:block">
        <img src="/login-hero.jpg" alt="Kopi GoMenu" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1410] via-[#1C1410]/40 to-transparent" />
        <div className="absolute bottom-0 left-0 p-12 text-white">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-orange-400">Resto & Cafe System</p>
          <h2 className="max-w-md text-4xl font-extrabold leading-tight tracking-tight">Dari meja ke dapur ke kasir, semua dalam satu alur.</h2>
          <p className="mt-4 max-w-sm text-sm text-stone-300">Waiter buka bill, dapur memasak, checker memastikan, kasir menerima pembayaran.</p>
        </div>
      </div>
      <div className="gm-grain flex items-center justify-center bg-stone-50 px-6 py-12">
        <form onSubmit={submit} className="gm-rise w-full max-w-sm space-y-6" data-testid="login-form">
          <div className="flex items-center gap-3">
            <img src="/icon-192.png" alt="GoMenu" className="h-12 w-12 rounded-2xl shadow-md" />
            <div>
              <h1 className="text-3xl font-extrabold tracking-tight text-zinc-900">GoMenu</h1>
              <p className="text-sm text-zinc-500">Masuk ke akun Anda</p>
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nama@gomenu.id" className="h-11 bg-white" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-white" />
          </div>
          {error && <p data-testid="login-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <Button data-testid="login-submit-btn" type="submit" disabled={busy} className="h-11 w-full rounded-xl bg-orange-600 text-base font-semibold hover:bg-orange-700 active:scale-95 transition-transform">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Masuk
          </Button>
          <p className="text-center text-xs text-zinc-400">Akun staf dibuat oleh Admin di menu Pengaturan Akun.</p>
        </form>
      </div>
    </div>
  );
}
